import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, actionEditColumn, actionPrintColumn, numeralColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";
import { InputText } from "primereact/inputtext";

export default function P230List({ dataTable, setDialog, data, onOpenExport }) {
    const history = useHistory();

    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    // const [globalFilter, setGlobalFilter] = useState(null);

    const actionBodyEdit = (obj) => {
        history.push({
            pathname: "231",
            state: {
                contractNo: data.contractNo,
                routeNo: data.routeNo,
                deliverNo: obj.seq,
            },
        });
    };

    const headerLabel = <span className="hidden-responsive">เพิ่มรายการใหม่</span>;
    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-success btn-hidden-responsive"
                label={headerLabel}
                icon="pi pi-plus"
                onClick={() =>
                    history.push({
                        pathname: "231",
                        state: {
                            contractNo: data.contractNo,
                            routeNo: data.routeNo,
                            deliverNo: 0,
                        },
                    })
                }
                autoFocus
            />
            {/* <span className="p-input-icon-left span-responsive" >
                <i className="pi pi-search" />
                <InputText type="search" placeholder="คำค้น" 
                className="btn-responsive"
                onInput={(e) => setGlobalFilter(e.target.value)}
                />
            </span> */}
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    header={header}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column sortable field="seq" header="ครั้งที่" body={(e) => normalColumn(e, "seq", "ครั้งที่")} style={{ textAlign: "center", width: "8%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="deliverAmount" header="จำนวนเงินรวมที่ส่งมอบงาน" body={(e) => numeralColumn(e, "deliverAmount", "จำนวนเงินรวมที่ส่งมอบงาน")} style={{ textAlign: "center", width: "12%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="letterNo" header="หนังสือส่งมอบงานเลขที่" body={(e) => normalColumn(e, "letterNo", "หนังสือส่งมอบงานเลขที่")} style={{ textAlign: "center", width: "12%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="letterDate" header="ลงวันที่" body={(e) => normalColumn(e, "letterDate", "ลงวันที่")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="deliverMeetingDate" header="ตรวจรับวันที่" body={(e) => normalColumn(e, "deliverMeetingDate", "ตรวจรับวันที่")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="remark" header="หมายเหตุ" body={(e) => normalColumn(e, "remark", "หมายเหตุ")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column header="แก้ไข" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                    <Column header="พิมพ์" body={(e) => actionPrintColumn(e, onOpenExport)} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>
        </div>
    );
}
